import { render, staticRenderFns } from "./appriskcustomer.vue?vue&type=template&id=2ea57952"
import script from "./appriskcustomer.vue?vue&type=script&lang=js"
export * from "./appriskcustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports